(function() {
    'use strict';

    const BundleGalleryFilter = {
        mediaGallery: null,
        activeInstanceId: null,

        init() {
            const bundleGallery = document.querySelector('[data-bundle-gallery]');
            if (!bundleGallery) return;

            this.mediaGallery = document.querySelector('media-gallery');
            if (!this.mediaGallery) return;

            const firstBundleItem = document.querySelector('.bundle-item');
            if (firstBundleItem) {
                this.activeInstanceId = firstBundleItem.dataset.bundleInstance;
            }

            // Ensure sticky preview is visible on init
            this.ensureStickyPreviewVisible();

            setTimeout(() => {
                this.filterGallery();
                this.attachColorChangeListeners();
            }, 500);
        },

        normalize(value) {
            return value.toLowerCase().trim().replace(/\s+/g, '-');
        },

        getActiveInstanceColor() {
            if (!this.activeInstanceId) return null;

            const activeBundleItem = document.querySelector(`.bundle-item[data-bundle-instance="${this.activeInstanceId}"]`);
            if (!activeBundleItem) return null;

            const colorSwatch = activeBundleItem.querySelector('.bundle-option-swatches.color-swatches input[type="radio"]:checked');
            
            if (colorSwatch) {
                return this.normalize(colorSwatch.value);
            }

            return null;
        },

        ensureStickyPreviewVisible() {
            const stickyPreview = document.querySelector('.product__media[data-sticky-preview]');
            if (stickyPreview) {
                stickyPreview.removeAttribute('hidden');
                stickyPreview.style.display = '';
                console.log('Sticky preview made visible');
            } else {
                console.log('Sticky preview not found');
            }
        },

        filterGallery() {
            if (!this.mediaGallery || !this.activeInstanceId) return;

            const activeColor = this.getActiveInstanceColor();

            console.log('Active Instance:', this.activeInstanceId);
            console.log('Active Color:', activeColor);

            if (!activeColor) {
                this.showAllMediaForInstance(this.activeInstanceId);
                return;
            }

            const expectedConnect = `color_${activeColor}`;

            // Filter main gallery media - EXPLICITLY exclude sticky preview
            const mediaItems = this.mediaGallery.querySelectorAll('.product__media[data-bundle-instance-id]');
            
            let visibleCount = 0;
            
            mediaItems.forEach(media => {
                // Skip if this is the sticky preview
                if (media.hasAttribute('data-sticky-preview')) {
                    console.log('Skipping sticky preview in filter');
                    return;
                }

                const instanceId = media.dataset.bundleInstanceId;
                const gangConnect = media.dataset.gangConnect;
                
                const belongsToActiveInstance = instanceId === this.activeInstanceId;
                const colorMatches = gangConnect === expectedConnect;
                const shouldShow = belongsToActiveInstance && colorMatches;
                
                if (shouldShow) {
                    media.removeAttribute('hidden');
                    visibleCount++;
                } else {
                    media.setAttribute('hidden', '');
                }
            });

            console.log('Visible media items:', visibleCount);

            // Filter thumbnails
            const thumbnails = this.mediaGallery.querySelectorAll('.product__thumbnail[data-bundle-instance-id]');
            
            thumbnails.forEach(thumb => {
                const instanceId = thumb.dataset.bundleInstanceId;
                const gangConnect = thumb.dataset.gangConnect;
                
                const belongsToActiveInstance = instanceId === this.activeInstanceId;
                const colorMatches = gangConnect === expectedConnect;
                const shouldShow = belongsToActiveInstance && colorMatches;
                
                if (shouldShow) {
                    thumb.removeAttribute('hidden');
                } else {
                    thumb.setAttribute('hidden', '');
                }
            });

            // Hide non-bundle media but NOT sticky preview
            const mediaWithoutBundle = this.mediaGallery.querySelectorAll('.product__media:not([data-bundle-instance-id]):not([data-sticky-preview])');
            console.log('Non-bundle media to hide:', mediaWithoutBundle.length);
            mediaWithoutBundle.forEach(media => media.setAttribute('hidden', ''));

            const thumbsWithoutBundle = this.mediaGallery.querySelectorAll('.product__thumbnail:not([data-bundle-instance-id])');
            thumbsWithoutBundle.forEach(thumb => thumb.setAttribute('hidden', ''));

            // FORCE sticky preview to be visible
            this.ensureStickyPreviewVisible();

            this.updateGalleryUI();
        },

        showAllMediaForInstance(instanceId) {
            if (!this.mediaGallery) return;

            const mediaItems = this.mediaGallery.querySelectorAll('.product__media[data-bundle-instance-id]');
            mediaItems.forEach(media => {
                // Skip sticky preview
                if (media.hasAttribute('data-sticky-preview')) {
                    return;
                }

                const belongsToInstance = media.dataset.bundleInstanceId === instanceId;
                if (belongsToInstance) {
                    media.removeAttribute('hidden');
                } else {
                    media.setAttribute('hidden', '');
                }
            });

            const thumbnails = this.mediaGallery.querySelectorAll('.product__thumbnail[data-bundle-instance-id]');
            thumbnails.forEach(thumb => {
                const belongsToInstance = thumb.dataset.bundleInstanceId === instanceId;
                if (belongsToInstance) {
                    thumb.removeAttribute('hidden');
                } else {
                    thumb.setAttribute('hidden', '');
                }
            });

            const mediaWithoutBundle = this.mediaGallery.querySelectorAll('.product__media:not([data-bundle-instance-id]):not([data-sticky-preview])');
            mediaWithoutBundle.forEach(media => media.setAttribute('hidden', ''));

            const thumbsWithoutBundle = this.mediaGallery.querySelectorAll('.product__thumbnail:not([data-bundle-instance-id])');
            thumbsWithoutBundle.forEach(thumb => thumb.setAttribute('hidden', ''));

            // FORCE sticky preview to be visible
            this.ensureStickyPreviewVisible();

            this.updateGalleryUI();
        },

        updateGalleryUI() {
            if (typeof this.mediaGallery.countMediaGallery === 'function') {
                this.mediaGallery.countMediaGallery();
            }

            const slider = this.mediaGallery.querySelector('slider-element');
            if (slider && typeof slider.update === 'function') {
                slider.update();
            }

            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        },

        setActiveInstance(instanceId) {
            this.activeInstanceId = instanceId;
            console.log('Active instance changed to:', instanceId);
        },

        attachColorChangeListeners() {
            const allRadios = document.querySelectorAll('.bundle-option-swatches input[type="radio"]');
            
            console.log('Found option radios:', allRadios.length);

            allRadios.forEach(radio => {
                radio.addEventListener('change', (e) => {
                    const swatchGroup = e.target.closest('.bundle-option-swatches');
                    if (swatchGroup) {
                        const instanceId = swatchGroup.dataset.bundleInstance;
                        
                        console.log('Option changed in instance:', instanceId);
                        console.log('New value:', e.target.value);
                        
                        this.setActiveInstance(instanceId);
                        
                        setTimeout(() => {
                            this.filterGallery();
                        }, 50);
                    }
                });
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => BundleGalleryFilter.init());
    } else {
        BundleGalleryFilter.init();
    }

})();